import { Link, useSearchParams } from "react-router-dom";

const MESSAGES: Record<string, string> = {
  expired: "Your sign-in took too long or was interrupted. Please start again.",
  github: "GitHub didn't complete the sign-in. Please try again.",
  email: "Please use a GitHub account with a permanent (non-disposable) verified email address.",
  consent: "Both required consents are needed to take part.",
  not_reviewer: "This GitHub account isn't on the reviewer list.",
  rate_limited: "Too many sign-in attempts. Please wait a while and try again.",
};

export function SignInError() {
  const [params] = useSearchParams();
  const reason = params.get("reason") ?? "";
  return (
    <main className="page">
      <h1>Sign-in didn't complete</h1>
      <p role="alert">{MESSAGES[reason] ?? "Something went wrong. Please try again."}</p>
      <p>
        <Link to="/consent">Start again</Link>
      </p>
    </main>
  );
}
